var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 51C51 22.7821 28.1379 0 0 0V51C0 79.1379 22.7821 102 51 102C79.1379 102 102 79.2179 102 51V0C73.7821 0 51 22.7821 51 51Z",
    fill: "#20A76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlant);
export default __webpack_public_path__ + "static/media/GreenPlant.c7f3330db01588df5fd02af46931a5a1.svg";
export { ForwardRef as ReactComponent };